import type { JSX } from "react";
import { translate } from "app/filters/i18nFilter";
import { CategoryBenchmarkDropdown } from "app/components/React/CategoryBenchmarkDropdown/CategoryBenchmarkDropdown";
import { getNoCategoryItem } from "app/components/React/CategoriesDropdown/CategoryPicker";
import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";
import { brandCustomCategoryId } from "app/services/category/userCustomCategoryService";
import type { ICategory } from "app/common/services/categoryService.types";
import type { DataMode } from "./ChannelsOverviewBarChartContainerFormat";

interface Props {
    isUnbound: boolean;
    categoryParam: string;
    dataMode: DataMode;
    durationParam: string;
    onCategorySelected: (category: ICategory) => void;
}

export function ChannelsOverviewBarChartCategoryBenchmark({
    isUnbound,
    categoryParam,
    dataMode,
    durationParam,
    onCategorySelected,
}: Props): JSX.Element {
    const noCategoryItem = getNoCategoryItem("mmx.channelsoverview.category.dropdown.placeholder");
    const isDisabled = isUnbound
        ? isUnbound
        : !swSettings.allowedDuration(durationParam, "IndustryAnalysis");

    const handleCategorySelected = (category: ICategory) => {
        const { id, isCustomCategory } = category;
        const trackId = isCustomCategory ? brandCustomCategoryId(id) : id;

        onCategorySelected(category);
        allTrackers.dispatchTrackEvent(
            "Drop Down",
            "click",
            `benchmark comparison/${trackId}/${dataMode}`,
        );
    };

    const handleCategoryDropdownToggle = (isOpen: boolean) => {
        const trackState = isOpen ? "open" : "close";
        allTrackers.dispatchTrackEvent("Drop Down", trackState, "benchmark comparison");
    };

    return (
        <CategoryBenchmarkDropdown
            excludeCustomCategoriesWithSegments
            isDropdownDisabled={isDisabled}
            isTooltipVisible={!isUnbound}
            category={categoryParam}
            text={{
                tooltip: isDisabled
                    ? "mmx.bar.benchmark.pickcategory.disabled"
                    : "mmx.bar.benchmark.pickcategory",
                searchPlaceHolder: translate("mmx.channelsoverview.dropdown.search.placeholder"),
            }}
            placeholder={noCategoryItem}
            buttonWidth={238}
            onDropdownToggleCallback={handleCategoryDropdownToggle}
            onCategorySelectedCallback={handleCategorySelected}
        />
    );
}
